/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */
import AnnotationsHandler from '..';
import Utils from '../../utils/utils';
import { C11nEnv } from '../../interpreter/c11n-env';

import { evaluateExpressionOnLocalData } from './expression/utils';

interface PageListItem {
  [key: string]: unknown;
}

/**
 * Note: Only one pageList is supported in a path to leaf property.
 * @param value path to leaf property
 * @param c11nEnv c11nEnv object
 * @returns returns null or array of values for leaf property
 * @example Below are expected paths for value parameter
 * .pageList[].leafProp
 * .pageList[].page.leafProp
 * .page.pageList[].leafProp
 */

AnnotationsHandler.registerHandler('@FILTERED_LIST', (value: string, c11nEnv: C11nEnv): any[] | null => {
  const pageListPath = value.substring(1, value.indexOf('['));
  const remainingPropPath = value.substring(value.indexOf(']') + 2);
  const filterExpression = value.substring(value.indexOf('[') + 1, value.indexOf(']'));

  if (!c11nEnv) {
    return null;
  }
  const { useCustomContext } = c11nEnv;
  let data;
  if (!Utils.isEmpty(useCustomContext)) {
    data = useCustomContext;
    data = Utils.getIn(data, pageListPath);
  } else {
    data = c11nEnv.getValue(`.${pageListPath}`);
  }
  if (data && remainingPropPath.length > 0) {
    if (filterExpression) {
      data = data.filter((pageListItem: PageListItem) => {
        return evaluateExpressionOnLocalData(filterExpression, pageListItem);
      });
    }
    return data.map((pageListItem: PageListItem) => Utils.getIn(pageListItem, remainingPropPath));
  }
  return null;
});
